import React, {useEffect, useState} from 'react';
import {Link, useParams} from "react-router-dom";
// @ts-ignore

import {ReactComponent as PhoneIcon} from "../../../assets/svg/icon-phone.svg";
import {ReactComponent as SendIcon} from "../../../assets/svg/icon-send.svg";
import {DirectoryBar} from "../../../components/DirectoryBar";
import { BRAZE_EVENT } from '../../../constants/braze';
import { Bridge } from '../../../plugins/bridge';
import { ContentInfoEventProperties, ContentTabEventProperties } from '../../../types/amplitudeEventProperties';

export const DongseongroDetail = () => {
    useEffect(()=>{
        const contentInfo = {
            content_tab : '매장',
            content_id : 'Dongseongro',
            content_name : 'Dongseongro'
        }

        Bridge.sendAmplitude('content_viewed', contentInfo);    
        Bridge.sendBraze(BRAZE_EVENT.CONTENT_VIEWED, contentInfo);

    },[]);
    return (
        <>
            <DirectoryBar text="홈, 매장, 대구 동성로" />
        <div className="bodyclass -mx-4 -mt-4">
            <div className="sic_2_l_d">
                <img src={"https://s3.ap-northeast-2.amazonaws.com/carhartt-wip.entropyparadox.link/static/media/storeInfo/store-carhartt-dongseongro.jpeg"} alt="" />
                <div className="sic_2_txt_d sic_2_txt">
                    <h2>칼하트윕 스토어 대구 동성로</h2>
                    <h3>
                        대구광역시 중구 동성로1길<br/>29-31
                    </h3>
                    <div className="o_button">
                        <button className="wh-9 border-gray-300 border rounded-full grid place-content-center">
                            <a href="tel:0534240922"><PhoneIcon /></a>
                        </button>
                        <button className="wh-9 border-gray-300 border rounded-full grid place-content-center">
                            <a target="_blank" href="https://www.google.com/maps/place/%EC%B9%BC%ED%95%98%ED%8A%B8WIP+%EB%8C%80%EA%B5%AC+%EB%8F%99%EC%84%B1%EB%A1%9C/@35.867786,128.5930381,17z/data=!3m1!4b1!4m5!3m4!1s0x3565e32a01399847:0x47a3873de4a6709d!8m2!3d35.867786!4d128.5952268?hl=ko"><SendIcon /></a>
                        </button>
                    </div>
                    <br/>
                    <h2 className="margin_top">매장정보</h2>
                    <h3>
                        전화번호: 053-424-0922
                        <br/>
                    </h3>
                    <br/>
                    <h2 className="margin_top">운영시간</h2>
                    <h3>
                        월요일 <span>12:00 - 21:00</span><br/>
                        화요일 <span>12:00 - 21:00</span><br/>
                        수요일 <span>12:00 - 21:00</span><br/>
                        목요일 <span>12:00 - 21:00</span><br/>
                        금요일 <span>12:00 - 22:00</span><br/>
                        토요일 <span>12:00 - 22:00</span><br/>
                        일요일 <span>12:00 - 22:00</span>
                    </h3>
                </div>
                <div className="sic_border">
                </div>
            </div>
            <div className="first_od od_1501"><img src={"https://s3.ap-northeast-2.amazonaws.com/carhartt-wip.entropyparadox.link/static/media/storeInfo/store_dongseongro_d1.jpg"} alt="" /></div>
            <div className="od_100"><img src={"https://s3.ap-northeast-2.amazonaws.com/carhartt-wip.entropyparadox.link/static/media/storeInfo/store_dongseongro_d2.jpg"} alt="" /></div>
            <div className="od_150"><img src={"https://s3.ap-northeast-2.amazonaws.com/carhartt-wip.entropyparadox.link/static/media/storeInfo/store_dongseongro_d3.jpg"} alt="" /></div>
            <div className="od_55"><img src={"https://s3.ap-northeast-2.amazonaws.com/carhartt-wip.entropyparadox.link/static/media/storeInfo/store_dongseongro_d4.jpg"} alt="" /></div>
            <div className="od_1501"><img src={"https://s3.ap-northeast-2.amazonaws.com/carhartt-wip.entropyparadox.link/static/media/storeInfo/store_dongseongro_d5.jpg"} alt="" /></div>
        </div>
        </>
    );
};
